<template>
  <b-card>
    <b-card-title>
      <h3>Trip Cancellation Section</h3>
    </b-card-title>
    <base-overlay
      :show="tripInfoLoading.cancellation"
    >
      <b-table
        v-if="tripInfoLoading.cancellation == false"
        :fields="fields"
        :items="items"
        class="position-relative"
        responsive
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(created_at)="data">
          {{ data.item.created_at | formatDate }}
        </template>
        <template #cell(cancellationReasonLabel)="">
          {{ cancellationReasonlabel }}
        </template>
      </b-table>
    </base-overlay>
  </b-card>
</template>

<script>
import { inject, computed, ref } from '@vue/composition-api'
import {
  BCard, BCardTitle, BTable,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BCard, BCardTitle, BTable,
  },
  setup() {
    const trip = inject('trip')
    const cancellationReasonDetails = ref({})
    const cancellationReasonlabel = ref('')
    const tripInfoLoading = inject('tripInfoLoading')
    const items = computed(() => [trip.value?.cancellationDetails])
    const GetCancellations = async () => {
      const { configuration_key } = trip.value
      const cancellationReasonId = trip.value.cancellation_reason_id
      if (cancellationReasonId) {
        const modifiedVariable = configuration_key.replace(/(.*?::.*?)::/, '$1/')
        const res = await axiosIns.get(`trips/configurations/${modifiedVariable}`)
        const cancellationReasons = res.data.data.cancellation_reasons
        const filteredReasons = cancellationReasons.filter(reason => reason.id === cancellationReasonId)
        cancellationReasonDetails.value = filteredReasons
        cancellationReasonlabel.value = filteredReasons[0].label
      }
    }
    GetCancellations()
    const fields = [
      {
        label: 'Cancellation Reason',
        key: 'cancellationReasonLabel',
      },
      {
        label: 'Created At',
        key: 'created_at',
      },
      {
        label: 'Action By',
        key: 'metadata',
        formatter: val => val.action_by,
      },
      {
        label: 'Paying Status',
        key: 'payingStatus',
      },
      {
        label: 'State',
        key: 'cancellationState',
      },
    ]
    return {
      items,
      fields,
      trip,
      tripInfoLoading,
      GetCancellations,
      cancellationReasonDetails,
      cancellationReasonlabel,
    }
  },
}
</script>

<style>

</style>
